import {
  ApplyOnStatus,
  RegularBenefitVariant,
} from '../../../../../../../typings'

export const EMPTY_PERCENTUAL_LOYALTY = {
  type: RegularBenefitVariant.PercentualLoyalty,
  value: undefined,
  status: ApplyOnStatus.Invoiced,
}
